import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectEssSwitch } from '../store/slices/essSwitchSlice';
import { selectTgsSwitch } from '../store/slices/tgsSwitchSlice';
import { selectTesSwitch } from '../store/slices/tesSwitchSlice';
import {
  handleReportStatus,
  selectReportStatus,
} from '../store/slices/reportStatusSlice';
import TitleContainer from '../TitleContainer';
import EachLocationReportStatus from './EachLocationReportStatus';
import { useEffect } from 'react';
import { useGetAllSSRsQueries, useGetThermocouplesQueries } from '../../hooks';
import { selectUnits } from '../store/slices/settings/unitsSlice';

const ReportStatusMain = () => {

  const dispatch = useDispatch();
  const locations = useSelector(selectReportStatus);
  const { essSwitch,flatEssSwitch } = useSelector(selectEssSwitch);
  const { tgsSwitch,flatTgsSwitch } = useSelector(selectTgsSwitch);
  const { tesSwitch,flatTesSwitch } = useSelector(selectTesSwitch);
  const { isF } = useSelector(selectUnits);
  const { allLocations } = locations;


  useGetAllSSRsQueries(flatEssSwitch, 'ESS', { faultedOnly: false });
  useGetAllSSRsQueries(flatTesSwitch, 'TES', { faultedOnly: false });
  useGetThermocouplesQueries(flatEssSwitch, 'ess');
  useGetThermocouplesQueries(flatTesSwitch, 'tes');

  useEffect(() => {
    dispatch(handleReportStatus({ essSwitch, tgsSwitch, tesSwitch, isF }));
  }, [essSwitch, tgsSwitch, tesSwitch, isF]);

  return (
    <Wrapper>
      <TitleContainer title='report status' />
      {allLocations.map((location, index) => (
       
        <EachLocationReportStatus
          key={index}
          mainIndex={index}
          location={location}
          allLocations={allLocations}
        />
      ))}
    </Wrapper>
  );
};

export default ReportStatusMain;

const Wrapper = styled.div`
  min-height: 674px !important;
  width: 1216px;
`;

